import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getScreenedCandidatesService,
  scheduleInterviewsFromSourcedProfileService,
  scheduleMyUploadsCandidateInterviews,
  updateCandidateEmailService,
} from '../../Services/CandidateManagement.service';
import {
  generateAnalysisReport,
  removeCandidateFromSelectedList,
  removeSelectedCandidates,
  setCandidateLoading,
  sortTableByNameReducer,
  toggleCandidateloading,
  toggleReportModalState,
  toggleSchedulePopupState,
  toggleSelectAllState,
  unselectAllCandidatesReducer,
  updateCandidateCatagory,
  updateCandidateEmail,
  updateCandidateSelection,
  updateScreenedCandidatesData,
  updateSelectAllCandidateReducer,
  updateSourcedCandidateCatagory,
} from '../../store/slices/candidateManagementSlice';
import {
  ArrowDown10,
  ArrowDownZA,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpDown,
  Check,
  ChevronsLeft,
  ChevronsRight,
  CircleX,
  Pencil,
  Search,
  SlidersHorizontal,
  Trash,
  XCircle,
} from 'lucide-react';
import { getSourcedCandidatesThunk } from '../../store/thunks/InterviewThunk';
import { getQualifiedOutreachCandidatesThunk } from '../../store/thunks/FindCandidatesThunk';
import { useSourcingConfig } from '../../contexts/SourcingConfigContext';
import AnalysisReportModal from '../common/AnalysisReportModal';
import ScreeningBreakdownModal from '../../sourcing/components/screening/ScreeningBreakdownModal';
import Loader from '../Loader';
import axios from 'axios';
import { updateAllSources } from '../../store/slices/filterOptionsSlice';
import MyUploadsTable from './MyUploadsTable';
import { toast } from 'react-toastify';
import SourcedProfileTable from './SourcedProfileTable';
import ScheduleInterviewDialog from './ScheduleInterviewDialog';
import { addCandidatesToScheduledSection } from '../../store/slices/InterviewManagementSlice';
import CommonTable from './CommonTable';
import Pagination from './Pagination';

const SOURCING_URL = process.env.REACT_APP_SOURCING_API_URL;

function CandidateProfileTable() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const searchQuery = useSelector((state) => state.filterSlice.searchQuery);
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [candidateUniqueID, setCandidateUniqueID] = useState(null);
  const [isEditing, setisEditing] = useState(false);
  const [editingcandidateId, setEditingCandidateId] = useState(false);
  const [editingField, setEditingField] = useState('email');
  const [tempValue, setTempValue] = useState('');
  // Add this state near other useState declarations
  const [modalCandidate, setModalCandidate] = useState(null);
  const org_id = useSelector((state) => state.userSlice.org_id);
  // const [startIndex, setStartIndex] = useState(0);
  const [interviewDateRange, setInterviewDateRange] = useState([]);
  // Stores timezone + timeslot from ModernScheduleInterview for the current scheduling action
  const [scheduleOptions, setScheduleOptions] = useState({ timezone: null, timeslot: null });
  // const [endIndex, setEndIndex] = useState(9);
  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const activeSubSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubSubTab,
  );
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );

  const currentCandidate = useSelector(
    (state) => state.candidateManagementSlice.currentCandidate,
  );
  // Redux Filtering Work Starts here =========================================================

  const currentCols = useSelector(
    (state) => state.filterSlice.columnVisibility?.[activeTab]?.[activeSubTab],
  );

  const currentJobRole = useSelector(
    (state) => state.filterSlice.currentJobRole,
  );
  const currentJobId = useSelector(
    (state) => state.filterSlice.currentJobId,
  );

  const currentSortDir = useSelector(
    (state) => state.candidateManagementSlice.currentSortDir,
  );
  const isSchedulePopupOpen = useSelector(
    (state) => state.candidateManagementSlice.isSchedulePopupOpen,
  );
  const selectAllClicked = useSelector(
    (state) => state.candidateManagementSlice.selectAllClicked,
  );

  // get Current Selected Zip Info
  const currentZipUpload = useSelector(
    (state) => state.filterSlice.currentZipUpload,
  );

  const currentSource = useSelector((state) => state.filterSlice.currentSource);
  const applyNow = useSelector((state) => state.filterSlice.applyNow);
  // Get Current Resume Score Filter
  const currentScoreRange = useSelector(
    (state) => state.filterSlice.currentScoreRange,
  );

  // get Current Selected Date info
  const dateRange = useSelector((state) => state.filterSlice.dateRange);

  // Filtering by Resume Score
  const filterByResumeScore = (candidates) => {
    const { min: minScore, max: maxScore } = currentScoreRange || {};
    if (minScore === undefined || maxScore === undefined) return candidates;
    return candidates.filter((c) => {
      const score = c.score;
      return score >= minScore && score <= maxScore;
    });
  };
  //Filtering by BulkUpload date
  const filterByBulkUploadDate = (candidates, bulkUploadDate) => {
    if (!bulkUploadDate) return candidates;

    return candidates.filter((c) => c.bulk_upload_date === bulkUploadDate);
  };

  // FilterBydaterange
  const filterByDateRangeOld = (candidates, dateRange) => {
    const [startDate, endDate] = dateRange || [];

    if (!startDate || !endDate) return candidates;

    const startTime = new Date(startDate).setHours(0, 0, 0, 0);
    const endTime = new Date(endDate).setHours(23, 59, 59, 999);

    return candidates.filter((c) => {
      const dateField =
        activeSubTab === 'SOURCED_CANDIDATES'
          ? c.applied_at
          : c.bulk_upload_date;

      if (!dateField) return false;

      const candidateTime = new Date(dateField).getTime();
      if (activeSubTab === 'SOURCED_CANDIDATES') {
        console.log({ dateField, candidateTime, startTime, endTime });
      }
      return candidateTime >= startTime && candidateTime <= endTime;
    });
  };

  const filterByDateRange = (candidates, dateRange) => {
    const [startDate, endDate] = dateRange || [];
    if (!startDate || !endDate) return candidates;

    const startTime = new Date(startDate).setHours(0, 0, 0, 0);
    const endTime = new Date(endDate).setHours(23, 59, 59, 999);

    return candidates.filter((c) => {
      // Use _tableSource if present, otherwise fall back to activeSubTab.
      // Outreached rows carry applied_at too (mapped from responded_at).
      const usesAppliedAt =
        c._tableSource === 'SOURCED' ||
        c._tableSource === 'OUTREACHED' ||
        activeSubTab === 'SOURCED_CANDIDATES' ||
        activeSubTab === 'OUTREACHED';
      const dateField = usesAppliedAt ? c.applied_at : c.bulk_upload_date;
      if (!dateField) return false;
      const candidateTime = new Date(dateField).getTime();
      return candidateTime >= startTime && candidateTime <= endTime;
    });
  };

  //Filter By Job Role
  const filterByJobRole = (candidates) => {
    // console.log({ currentJobRole, currentJobId });
    
    // Priority 1: Filter by Job ID if available
    if (currentJobId && currentJobId !== 'all') {
      return candidates.filter(
        (c) => 
          (c.job_id && c.job_id === currentJobId) || 
          (c.jd_id && c.jd_id === currentJobId)
      );
    }

    // Priority 2: Filter by Job Role name
    if (!currentJobRole || currentJobRole === '' || currentJobRole === 'ALL') {
      return candidates;
    }

    return candidates.filter(
      (c) =>
        c.job_role && c.job_role.toLowerCase() === currentJobRole.toLowerCase(),
    );
  };

  //Filter By Source
  const filterBySource = (candidates) => {
    if (!currentSource || currentSource === 'All') {
      return candidates;
    }

    return candidates.filter((candidate) => {
      const source = candidate.source_of_application || candidate.source || '';

      return source.toLowerCase() === currentSource.toLowerCase();
    });
  };

  const shortListedCandidates = useSelector((state) => {
    const candidates = state.candidateManagementSlice.shortListedCandidates;

    const afterBulkUpload = filterByBulkUploadDate(
      candidates,
      state.filterSlice.currentZipUpload?.bulk_upload_date,
    );

    const afterDateRangeFilter = filterByDateRange(
      afterBulkUpload,
      state.filterSlice.dateRange,
    );

    const afterJobRoleFilter = filterByJobRole(afterDateRangeFilter);

    const afterReumseFilter = filterByResumeScore(afterJobRoleFilter);

    return afterReumseFilter;
  });

  const retrofitCandidates = useSelector((state) =>
    filterByResumeScore(
      filterByJobRole(
        filterByDateRange(
          filterByBulkUploadDate(
            state.candidateManagementSlice.retrofitCandidates,
            state.filterSlice.currentZipUpload?.bulk_upload_date,
          ),
          state.filterSlice.dateRange,
        ),
      ),
    ),
  );

  const invalidCandidates = useSelector((state) => {
    const candidates = state.candidateManagementSlice.invalidCandidates;

    return filterByResumeScore(
      filterByJobRole(
        filterByDateRange(
          filterByBulkUploadDate(
            candidates,
            state.filterSlice.currentZipUpload?.bulk_upload_date,
          ),
          state.filterSlice.dateRange,
        ),
      ),
    );
  });

  const selectedCandidates = useSelector(
    (state) => state.candidateManagementSlice.selectedCandidates,
  );
  // console.log({ selectedCandidates });
  // =======================================================================================
  const sortConfig = useSelector(
    (state) => state.candidateManagementSlice.sortConfig,
  );

  const handleSort = (key) => {
    const currentKey = sortConfig.key;
    const currentDir = sortConfig.direction;

    let newDirection;
    if (currentKey !== key) newDirection = 'asc';
    else if (currentDir === 'asc') newDirection = 'desc';
    else if (currentDir === 'desc') newDirection = null;
    else newDirection = 'asc';

    dispatch(
      sortTableByNameReducer({
        activeSubTab,
        activeSubSubTab,
        key,
        direction: newDirection,
      }),
    );
  };

  // tmp Job Id for fetching data take it from redux later
  const jobId = 'all';
  const selectionCount = useSelector(
    (state) => state.candidateManagementSlice.selectionCount,
  );

  const allScreenedCandidates = useSelector(
    (state) => state.candidateManagementSlice.allScreenedCandidates,
  );
  const sourcedCandidates = useSelector(
    (state) => state.candidateManagementSlice.sourcedCandidates,
  );
  const notifications = useSelector(
    (state) => state.candidateManagementSlice.notifications,
  );

  const sourcedShortlistedCandidates = useSelector((state) => {
    const source_filtered_data = filterBySource(
      state.candidateManagementSlice.sourcedShortlistedCandidates,
    );
    const date_filtered_data = filterByDateRange(
      source_filtered_data,
      dateRange,
    );
    const filteredByJobRole = filterByJobRole(date_filtered_data);

    const filteredByResumeScore = filterByResumeScore(filteredByJobRole);

    return filteredByResumeScore;
  });

  const sourcedRetrofitCandidates = useSelector((state) => {
    const source_filtered_data = filterBySource(
      state.candidateManagementSlice.sourcedRetrofitCandidates,
    );
    const date_filtered_data = filterByDateRange(
      source_filtered_data,
      dateRange,
    );

    const jobFilterData = filterByJobRole(date_filtered_data);

    const filteredByResumeScore = filterByResumeScore(jobFilterData);

    return filteredByResumeScore;
  });

  /* ── Outreached (qualified) candidates ─────────────────────────────────────
     Job scoping happens server-side (the thunk sends job_id, or omits it for the
     "All Jobs" scope), so the client-side job filter is deliberately not applied
     here — the rows may not carry a job_id to match on. */
  const { sourcingEnabled } = useSourcingConfig();
  const outreachedCandidates = useSelector(
    (state) => state.candidateManagementSlice.outreachedCandidates,
  );
  const outreachedLoading = useSelector(
    (state) => state.candidateManagementSlice.outreachedLoading,
  );
  const jobRolesForDropDown = useSelector(
    (state) => state.interviewManagementSlice.jobRolesForDropDown,
  );

  // The header's job dropdown sets currentJobRole (a name); currentJobId is only set
  // by deep links. Resolve the id the same priority order filterByJobRole uses, so
  // both agree on what "the selected job" means. null ⇒ All Jobs ⇒ org-wide read.
  const outreachJobId = useMemo(() => {
    if (currentJobId && currentJobId !== 'all') return currentJobId;
    if (
      !currentJobRole ||
      currentJobRole === 'ALL' ||
      currentJobRole === 'All Job Roles'
    ) {
      return null;
    }
    const match = (jobRolesForDropDown || []).find(
      (r) => r.role?.toLowerCase() === currentJobRole.toLowerCase(),
    );
    return match?.id ?? null;
  }, [currentJobId, currentJobRole, jobRolesForDropDown]);

  const outreachJobRole = useMemo(() => {
    if (
      !currentJobRole ||
      currentJobRole === 'ALL' ||
      currentJobRole === 'All Job Roles'
    ) {
      return '';
    }
    return currentJobRole;
  }, [currentJobRole]);

  const resume_score_threshold = useSelector(
    (state) => state.candidateManagementSlice.resume_score_threshold,
  );

  const stage = useSelector(
    (state) => state.candidateManagementSlice.activeSubSubTab,
  );

  // Outreached candidates have no resume analysis to report on — their equivalent is
  // the screening answers they submitted, so the row opens that breakdown instead.
  const [outreachBreakdownRow, setOutreachBreakdownRow] = useState(null);

  const handleReportClick = (candidate) => {
    if (candidate?._tableSource === 'OUTREACHED') {
      setOutreachBreakdownRow(candidate);
      return;
    }
    // Opening a report must not touch the checkbox selection: that list drives the
    // Download / Schedule buttons. Scheduling from the report passes the candidate
    // explicitly via modalCandidate instead.
    dispatch(generateAnalysisReport({ candidate }));
  };

  const currentReport = useSelector(
    (state) => state.candidateManagementSlice.analysisReport,
  );

  const filterDataforMyUploadtablesold = async (
    freshCandidates,
    freshThreshold,
    freshNotifications,
  ) => {
    const candidatesToUse = freshCandidates ?? allScreenedCandidates;
    const threshold = freshThreshold ?? resume_score_threshold;
    const notificationsToUse = freshNotifications ?? notifications;
    if (notificationsToUse.length > 0) {
      const notificationsToUse = notifications.filter((notif) => {
        if (filterDateRange[0] && filterDateRange[1]) {
          const uploadDate = new Date(notif.bulk_upload_date);
          const startDate = new Date(filterDateRange[0]);
          const endDate = new Date(filterDateRange[1]);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          return uploadDate >= startDate && uploadDate <= endDate;
        }
        return true;
      });

      let filteredCandidates = candidatesToUse;
      if (filterDateRange[0] && filterDateRange[1]) {
        const filteredUploadIds = new Set(
          notificationsToUse.map((n) => n.upload_id),
        );
        filteredCandidates = candidatesToUse.filter((c) =>
          filteredUploadIds.has(c.upload_id),
        );
      }

      if (filteredCandidates.length > 0) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = (email) => {
          return email && typeof email === 'string' && emailRegex.test(email);
        };

        const shortlistedCandidates = filteredCandidates.filter(
          (c) => c.score >= threshold && isValidEmail(c.candidate_email),
        );

        const retrofitCandidates = filteredCandidates.filter(
          (c) =>
            c.score < threshold &&
            c.score !== null &&
            isValidEmail(c.candidate_email),
        );

        const invalidCandidates = filteredCandidates.filter(
          (c) =>
            !isValidEmail(c.candidate_email) ||
            c.score === null ||
            c.candidate_email === 'not provided' ||
            c.candidate_email === '',
        );

        dispatch(
          updateCandidateCatagory({
            candidates: shortlistedCandidates,
            catagory: 'SHORTLISTED',
          }),
        );

        dispatch(
          updateCandidateCatagory({
            candidates: retrofitCandidates,
            catagory: 'RETROFIT',
          }),
        );

        dispatch(
          updateCandidateCatagory({
            candidates: invalidCandidates,
            catagory: 'INVALID',
          }),
        );
      } else {
        dispatch(
          updateCandidateCatagory({
            candidates: [],
            catagory: 'SHORTLISTED',
          }),
        );

        dispatch(
          updateCandidateCatagory({
            candidates: [],
            catagory: 'RETROFIT',
          }),
        );

        dispatch(
          updateCandidateCatagory({
            candidates: [],
            catagory: 'INVALID',
          }),
        );
      }

      setCurrentPage(1);
    }
  };

  const filterDataforMyUploadtables = async (
    freshCandidates,
    freshThreshold,
    freshNotifications,
  ) => {
    const candidatesToUse = Array.isArray(freshCandidates)
      ? freshCandidates
      : allScreenedCandidates;
    const threshold = freshThreshold ?? resume_score_threshold;
    const notificationsToUse = Array.isArray(freshNotifications)
      ? freshNotifications
      : notifications; // ✅ single declaration

    if (notificationsToUse.length > 0) {
      // ✅ use notificationsToUse here, NOT notifications
      const filteredNotifications = notificationsToUse.filter((notif) => {
        if (filterDateRange[0] && filterDateRange[1]) {
          const uploadDate = new Date(notif.bulk_upload_date);
          const startDate = new Date(filterDateRange[0]);
          const endDate = new Date(filterDateRange[1]);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          return uploadDate >= startDate && uploadDate <= endDate;
        }
        return true;
      });

      let filteredCandidates = candidatesToUse;
      if (filterDateRange[0] && filterDateRange[1]) {
        const filteredUploadIds = new Set(
          filteredNotifications.map((n) => n.upload_id), // ✅ filteredNotifications, not notificationsToUse
        );
        filteredCandidates = candidatesToUse.filter((c) =>
          filteredUploadIds.has(c.upload_id),
        );
      }

      if (filteredCandidates.length > 0) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = (email) =>
          email && typeof email === 'string' && emailRegex.test(email);

        const shortlistedCandidates = filteredCandidates.filter(
          (c) => c.score >= threshold && isValidEmail(c.candidate_email),
        );
        const retrofitCandidates = filteredCandidates.filter(
          (c) =>
            c.score < threshold &&
            c.score !== null &&
            isValidEmail(c.candidate_email),
        );
        const invalidCandidates = filteredCandidates.filter(
          (c) =>
            !isValidEmail(c.candidate_email) ||
            c.score === null ||
            c.candidate_email === 'not provided' ||
            c.candidate_email === '',
        );

        dispatch(
          updateCandidateCatagory({
            candidates: shortlistedCandidates,
            catagory: 'SHORTLISTED',
          }),
        );
        dispatch(
          updateCandidateCatagory({
            candidates: retrofitCandidates,
            catagory: 'RETROFIT',
          }),
        );
        dispatch(
          updateCandidateCatagory({
            candidates: invalidCandidates,
            catagory: 'INVALID',
          }),
        );
      } else {
        dispatch(
          updateCandidateCatagory({ candidates: [], catagory: 'SHORTLISTED' }),
        );
        dispatch(
          updateCandidateCatagory({ candidates: [], catagory: 'RETROFIT' }),
        );
        dispatch(
          updateCandidateCatagory({ candidates: [], catagory: 'INVALID' }),
        );
      }

      setCurrentPage(1);
    }
  };
  const handleNameSortClick = () => {
    // This function is now legacy as we use Redux-driven handleSort
  };

  const filterDataforSourcedProfiles = async (freshSourced, freshThreshold) => {
    const candidatesToUse = freshSourced ?? sourcedCandidates;
    const threshold = freshThreshold ?? resume_score_threshold; // ✅
    if (candidatesToUse.length === 0) return;
    const shortlistedCandidates = candidatesToUse.filter(
      (c) => c.score >= threshold,
    );
    const retrofitCandidates = candidatesToUse.filter(
      (c) => c.score < threshold && c.score !== null,
    );

    // 2️⃣ Extract unique sources
    const candidateSources = candidatesToUse
      .map((candidate) => candidate.source_of_application || candidate.source)
      .filter(
        (source) =>
          source &&
          source.trim() &&
          source.toLowerCase() !== 'public_application',
      )
      .map((source) => source.trim());

    const predefinedSources = ['LinkedIn', 'Naukri', 'Monster'];

    const uniqueSources = [
      'All',
      ...[...candidateSources, ...predefinedSources].filter(
        (source, index, array) => array.indexOf(source) === index,
      ),
    ];

    dispatch(updateAllSources(uniqueSources));

    dispatch(
      updateSourcedCandidateCatagory({
        candidates: shortlistedCandidates,
        catagory: 'SHORTLISTED',
      }),
    );
    dispatch(
      updateSourcedCandidateCatagory({
        candidates: retrofitCandidates,
        catagory: 'RETROFIT',
      }),
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      let candidatesToFilter = allScreenedCandidates;
      let sourcedToFilter = sourcedCandidates;
      let thresholdToUse = resume_score_threshold;
      let notificationsToUse = notifications; // ✅ different name to avoid conflict
      if (allScreenedCandidates.length <= 0) {
        dispatch(setCandidateLoading(true));
        const response = await getScreenedCandidatesService('all');
        if (!response) {
          dispatch(setCandidateLoading(false));
          return;
        }

        const {
          notifications: freshNotifications = [], // ✅ local const, different from let above
          all_candidates = [],
          resume_score_threshold: freshThreshold = 0,
          total_candidates,
          total_uploads,
        } = response;

        dispatch(
          updateScreenedCandidatesData({
            notifications: freshNotifications, // ✅ pass fresh, not stale
            all_candidates,
            resume_score_threshold: freshThreshold,
            total_candidates,
            total_uploads,
          }),
        );

        candidatesToFilter = all_candidates;
        thresholdToUse = freshThreshold;
        notificationsToUse = freshNotifications; // ✅ assign fresh to the let variable
      }

      if (sourcedCandidates.length === 0) {
        dispatch(setCandidateLoading(true));
        const result = await dispatch(getSourcedCandidatesThunk({ jobId }));
        sourcedToFilter = Array.isArray(result?.payload) ? result.payload : [];
      }

      await filterDataforMyUploadtables(
        candidatesToFilter,
        thresholdToUse,
        notificationsToUse,
      );
      await filterDataforSourcedProfiles(sourcedToFilter, thresholdToUse);

      dispatch(setCandidateLoading(false));
    };

    fetchData();
  }, [activeSubTab]);
  const getMyUploadsTableData = () => {
    if (activeSubTab === 'SOURCED_CANDIDATES') return [];
    if (activeSubTab === 'ALL' && currentSource && currentSource != 'All')
      return []; 
    
    let rawData = [];
    if (activeSubTab === 'ALL') {
      switch (stage) {
        case 'Shortlisted':
          rawData = [...shortListedCandidates];
          break;
        case 'Retrofit':
          rawData = [...retrofitCandidates];
          break;
        case 'Invalid':
          rawData = [...invalidCandidates];
          break;
        default: // 'All'
          rawData = [...shortListedCandidates, ...retrofitCandidates, ...invalidCandidates];
          break;
      }
    } else {
      switch (stage) {
        case 'Shortlisted':
          rawData = [...shortListedCandidates];
          break;
        case 'Retrofit':
          rawData = [...retrofitCandidates];
          break;
        case 'Invalid':
          rawData = [...invalidCandidates];
          break;
        default:
          rawData = [];
          break;
      }
    }

    // Ensure uniqueness by ID or email to prevent duplicated rows in UI
    const uniqueMap = new Map();
    rawData.forEach(c => {
      const stableKey = c._id || c.unique_id || c.candidate_email;
      if (stableKey) uniqueMap.set(stableKey, c);
    });
    
    let data = Array.from(uniqueMap.values());

    if (searchQuery.trim()) {
      data = data.filter((candidate) =>
        candidate.name?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    return data;
  };

  const handleSelectCandidate = (candidate) => {
    console.log('HandleUpdateCandidateClicked');
    dispatch(
      updateCandidateSelection({
        candidateId: candidate._id,
        value: !candidate?.isSelected,
      }),
    );
  };

  const myUploadsData = useMemo(
    () => getMyUploadsTableData().map(c => ({ ...c, _tableSource: 'MY_UPLOADS' })),
    [
      shortListedCandidates,
      retrofitCandidates,
      invalidCandidates,
      activeSubTab,
      stage,
      searchQuery, 
      sortConfig,
      applyNow,
      currentSource,
    ],
  );

  const getSourcedProfilesData = () => {
    if (activeSubTab === 'MY_UPLOADS') return [];
    if (activeSubTab === 'ALL' && currentZipUpload != 'All') return [];
    let data;
    if (activeSubTab === 'ALL') {
      // Merge both sourced categories for the combined view
      switch (stage) {
        case 'Shortlisted':
          data = [...sourcedShortlistedCandidates];
          break;
        case 'Retrofit':
          data = [...sourcedRetrofitCandidates];
          break;
        case 'Invalid':
          data = []; // sourced candidates don't have Invalid
          break;
        default: // 'All'
          data = [
            ...sourcedShortlistedCandidates,
            ...sourcedRetrofitCandidates,
          ];
      }
    } else {
      switch (stage) {
        case 'Shortlisted':
          data = [...sourcedShortlistedCandidates];
          break;
        case 'Retrofit':
          data = [...sourcedRetrofitCandidates];
          break;
        default:
          data = [];
      }
    }

    if (searchQuery.trim()) {
      data = data.filter((candidate) =>
        candidate.name?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }
    // data = filterByJobRole(data );
    return data;
  };

  const sourcedProfilesData = useMemo(() => {
    return getSourcedProfilesData().map((c) => ({
      ...c,
      _tableSource: 'SOURCED',
    }));
  }, [
    sourcedShortlistedCandidates,
    sourcedRetrofitCandidates,
    activeSubTab,
    stage,
    searchQuery,
    applyNow,
    currentZipUpload,
    sortConfig,
  ]);

  // Re-read whenever the job scope changes: "All Jobs" is an org-wide read, a selected
  // role is scoped to that job. Aborted on change so a slow org-wide walk can't land
  // after the user has narrowed to one role.
  useEffect(() => {
    // Outreach data only exists for orgs with sourcing enabled; sourcingEnabled is
    // false while the config is still loading, and the effect re-runs once it flips.
    //
    // Gated on the sub-tab as well as the tab: this component stays mounted across all
    // four SOURCED sub-tabs, so checking activeTab alone ran this multi-page walk on
    // All / Applications Received / My Uploads too, where outreachedData is always []
    // and the result was thrown away.
    if (
      activeTab !== 'SOURCED' ||
      activeSubTab !== 'OUTREACHED' ||
      !sourcingEnabled
    ) {
      return undefined;
    }
    const orgId = org_id || localStorage.getItem('current_org_id');
    if (!orgId) return undefined;

    const promise = dispatch(
      getQualifiedOutreachCandidatesThunk({
        orgId,
        jobId: outreachJobId,
        // Not used to fetch — carried on meta.arg so the reducer can stamp the scope's
        // job onto rows the sourcing service didn't attach one to.
        jobRole: outreachJobRole,
      }),
    );
    return () => promise.abort?.();
  }, [
    activeTab,
    activeSubTab,
    sourcingEnabled,
    outreachJobId,
    outreachJobRole,
    org_id,
    applyNow,
    dispatch,
  ]);

  const outreachedData = useMemo(() => {
    if (activeSubTab !== 'OUTREACHED') return [];

    // Rows arrive from the store already in ATS shape (see toAtsRow in
    // candidateManagementSlice) — mapping again here would fork them into copies the
    // selection reducers can't match against the ones the store holds.
    let data = outreachedCandidates;

    // The score-range filter is skipped on purpose: these rows have no resume score,
    // so applying it would empty the tab rather than narrow it.
    data = filterByDateRange(data, dateRange);

    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      data = data.filter((c) => c.name?.toLowerCase().includes(q));
    }

    return data;
  }, [
    outreachedCandidates,
    activeSubTab,
    dateRange,
    searchQuery,
    sortConfig,
    applyNow,
  ]);

  // The other sub-tabs reset the page inside their own filter passes; OUTREACHED has no
  // equivalent, so arriving from page 3 of My Uploads — or narrowing the job, search or
  // date range until fewer pages remain — left currentPage past the end and rendered an
  // empty tab. Scoped to OUTREACHED so the existing tabs keep their behaviour exactly.
  useEffect(() => {
    if (activeSubTab !== 'OUTREACHED') return;
    const lastPage = Math.max(1, Math.ceil(outreachedData.length / itemsPerPage));
    if (currentPage > lastPage) setCurrentPage(lastPage);
  }, [activeSubTab, outreachedData.length, itemsPerPage, currentPage]);

  const handleEdit = (candidate, field = 'email') => {
    console.log('Got Candidate To Edit');
    if (candidate === null) {
      setisEditing(false);
      setEditingCandidateId(null);
      setEditingField(null);
      return;
    }
    setisEditing(true);
    setEditingCandidateId(candidate._id);
    setEditingField(field);
    setTempValue(
      field === 'email'
        ? candidate.candidate_email || ''
        : candidate.contact_number || candidate.mobile || '',
    );
    setCandidateUniqueID(candidate.unique_id);
  };

  const handleSave = async (candidate) => {
    if (!candidate) {
      setisEditing(false);
      setEditingCandidateId(null);
      setEditingField(null);
      return;
    }
    if (!tempValue) return;

    if (editingField === 'email') {
      // Email regex validation
      const emailRegex =
        /^[a-zA-Z0-9._%+\-]{1,64}@[a-zA-Z0-9.\-]{1,253}\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(tempValue)) {
        toast.error('Please enter a valid email address');
        return;
      }

      if (tempValue === candidate?.candidate_email) {
        setisEditing(false);
        setEditingCandidateId(null);
        setEditingField(null);
        return;
      }
    } else {
      // Simple contact number check (can be more robust if needed)
      if (tempValue.length < 10) {
        toast.error('Please enter a valid contact number');
        return;
      }
      if (tempValue === (candidate?.mobile || candidate?.contact_number)) {
        setisEditing(false);
        setEditingCandidateId(null);
        setEditingField(null);
        return;
      }
    }

    const toastId = toast.loading(`Updating candidate ${editingField}...`);
    const isSourcedCandidate = candidate?._tableSource === 'SOURCED';
    // console.log(isSourcedCandidate)
    try {
      const isChanged = await updateCandidateEmailService(
        candidate?.upload_id,
        isSourcedCandidate ? candidate?._id : candidate?.unique_id,
        editingField === 'email' ? tempValue : null,
        isSourcedCandidate,
        editingField === 'contact' ? tempValue : null,
      );

      if (!isChanged) throw new Error();

      dispatch(
        updateCandidateEmail({
          candidate: {
            _id: candidate._id,
            [editingField === 'email' ? 'candidate_email' : 'mobile']: tempValue,
            // Also update contact_number if it exists to keep UI consistent
            ...(editingField === 'contact' && { contact_number: tempValue }),
          },
          activeSubTab,
          activeSubSubTab,
          field: editingField === 'email' ? 'candidate_email' : 'mobile',
        }),
      );

      setisEditing(false);
      setEditingCandidateId(null);
      setEditingField(null);

      toast.update(toastId, {
        render: `${editingField === 'email' ? 'Email' : 'Contact number'} updated successfully`,
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      setisEditing(false);
      setEditingCandidateId(null);
      setEditingField(null);
      toast.update(toastId, {
        render: `Something went wrong while updating candidate ${editingField}`,
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleSelectAllCandidates = async (value) => {
    // Select-all applies to the current page only (not every candidate across all
    // pages). Pass the current page's rows of whichever array this subtab renders;
    // the reducer scopes the selection to these rows.
    const displayedData =
      activeSubTab === 'SOURCED_CANDIDATES'
        ? sourcedProfilesData
        : activeSubTab === 'MY_UPLOADS'
          ? myUploadsData
          : activeSubTab === 'OUTREACHED'
            ? outreachedData
            : combinedData;
    const pageStart = (currentPage - 1) * itemsPerPage;
    const pageSlice = displayedData.slice(pageStart, pageStart + itemsPerPage);
    dispatch(
      updateSelectAllCandidateReducer({
        activeTab,
        activeSubSubTab,
        activeSubTab,
        value,
        candidates: pageSlice,
      }),
    );
  };

  const handleSortByName = async (dir) => {
    console.log({ dir });
    dispatch(
      sortTableByNameReducer({
        activeSubSubTab,
        activeTab,
        activeSubTab,
        value: dir,
      }),
    );
  };

  // const handlePageChange = (page) => {
  //   if (page < 1 || page > totalPages) return;

  //   setCurrentPage(page);
  //   setStartIndex((page - 1) * itemsPerPage);
  //   // setEndIndex(page * itemsPerPage);
  // };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    dispatch(toggleSelectAllState(false));
    setCurrentPage(page);
  };


  const handleCloseSchedulePopup = (val) => {
    // Drop the report candidate whether the dialog was confirmed or cancelled, so a
    // cancelled schedule can't leak into the next toolbar-driven schedule.
    setModalCandidate(null);
    if (isSchedulePopupOpen) {
      dispatch(toggleSchedulePopupState());
    }
  };

  const handleScheduleInterviewForCandidates = async (providedRange, options = {}) => {
    const rangeToUse = providedRange || interviewDateRange;
    // Resolve timezone: use passed option or browser/system fallback
    const timezone = options.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeslot = options.timeslot || null;
    let upload_id;
    // Scheduling from the report modal targets just that candidate; otherwise it's
    // whoever is ticked in the table.
    const candidatesToSchedule = modalCandidate ? [modalCandidate] : selectedCandidates;
    const toastId = toast.loading('Scheduling interviews...');
    if (activeSubTab === 'MY_UPLOADS' && candidatesToSchedule.length > 0) {
      const selectedUniqueIds = candidatesToSchedule.map(
        (candidate) => candidate.unique_id,
      );
      upload_id = candidatesToSchedule[0]?.upload_id;
      const payload = {
        unique_ids: selectedUniqueIds,
        start_date: rangeToUse[0]?.toISOString(),
        end_date: rangeToUse[1]?.toISOString(),
      };
      const response = await scheduleMyUploadsCandidateInterviews({
        uploadId: upload_id,
        uniqueIds: selectedUniqueIds,
        startDate: rangeToUse[0],
        endDate: rangeToUse[1],
        org_id,
        timezone,
        timeslot,
      });

      if (response) {
        toast.update(toastId, {
          render: 'Interviews scheduled successfully',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
        dispatch(removeSelectedCandidates(candidatesToSchedule.map((c) => c._id)));
        dispatch(addCandidatesToScheduledSection(candidatesToSchedule));
      } else {
        toast.update(toastId, {
          render: 'Failed to schedule interviews',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
      dispatch(
        updateSelectAllCandidateReducer({
          activeSubTab,
          activeSubSubTab,
          value: false,
        }),
      );
      setInterviewDateRange([]);
      // dispatch(toggleSchedulePopupState());
    }

    if (
      activeSubTab === 'SOURCED_CANDIDATES' &&
      candidatesToSchedule.length > 0
    ) {
      const response = await scheduleInterviewsFromSourcedProfileService({
        candidates: candidatesToSchedule,
        dateRange: rangeToUse,
        org_id: org_id,
        timezone,
        timeslot,
      });
      if (response) {
        const { successCount, alreadyScheduledCount, alreadyScheduledNames, scheduledIds } = response;

        if (successCount > 0) {
          toast.update(toastId, {
            render: `${successCount} interview${successCount > 1 ? 's' : ''} scheduled successfully`,
            type: 'success',
            isLoading: false,
            autoClose: 3000,
          });
        } else if (alreadyScheduledCount === 0) {
          toast.update(toastId, {
            render: 'Failed to schedule interviews',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          // dismiss the loading toast — the warning below is the only feedback
          toast.dismiss(toastId);
        }

        if (alreadyScheduledCount > 0) {
          toast.warning(
            `Already scheduled: ${alreadyScheduledNames.join(', ')}`,
            { autoClose: 5000 }
          );
        }

        if (scheduledIds.length > 0) {
          const newlyScheduled = candidatesToSchedule.filter(c => scheduledIds.includes(c._id));
          dispatch(removeSelectedCandidates(scheduledIds));
          dispatch(addCandidatesToScheduledSection(newlyScheduled));
        }
      } else {
        toast.update(toastId, {
          render: 'Failed to schedule interviews',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
      // dispatch(toggleSchedulePopupState());
    }

    if (activeSubTab === 'OUTREACHED' && selectedCandidates.length > 0) {
      // Emails are hidden in the sourcing list payload even when one is on file, so
      // resolve the missing ones before deciding who can't be scheduled.
      const resolved = await Promise.all(
        selectedCandidates.map(async (c) => {
          if (c.candidate_email) return c;
          try {
            const { data } = await axios.get(
              `${SOURCING_URL}/sourcing/candidate/${c.candidate_id || c._id}/contact`,
            );
            return data?.email ? { ...c, candidate_email: data.email } : c;
          } catch {
            return c;
          }
        }),
      );

      // Both are hard requirements of the scheduling endpoint: no email means no
      // invite to send, no job means no interview configuration to build from.
      const schedulable = resolved.filter(
        (c) => c.candidate_email && (c.jd_id || c.job_id),
      );
      const blocked = resolved.filter((c) => !schedulable.includes(c));

      if (schedulable.length === 0) {
        toast.update(toastId, {
          render: blocked.some((c) => !(c.jd_id || c.job_id))
            ? 'These candidates are not linked to a job role — select a job role above to schedule them.'
            : 'No email on file for the selected candidates.',
          type: 'error',
          isLoading: false,
          autoClose: 4000,
        });
        return;
      }

      const response = await scheduleInterviewsFromSourcedProfileService({
        candidates: schedulable,
        dateRange: rangeToUse,
        org_id,
        timezone,
        timeslot,
      });

      if (response) {
        const { successCount, alreadyScheduledCount, alreadyScheduledNames, scheduledIds } =
          response;

        if (successCount > 0) {
          toast.update(toastId, {
            render: `${successCount} interview${successCount > 1 ? 's' : ''} scheduled successfully`,
            type: 'success',
            isLoading: false,
            autoClose: 3000,
          });
        } else if (alreadyScheduledCount === 0) {
          toast.update(toastId, {
            render: 'Failed to schedule interviews',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.dismiss(toastId);
        }

        if (alreadyScheduledCount > 0) {
          toast.warning(`Already scheduled: ${alreadyScheduledNames.join(', ')}`, {
            autoClose: 5000,
          });
        }

        if (scheduledIds.length > 0) {
          const newlyScheduled = schedulable.filter((c) =>
            scheduledIds.includes(c._id),
          );
          dispatch(removeSelectedCandidates(scheduledIds));
          dispatch(addCandidatesToScheduledSection(newlyScheduled));
        }
      } else {
        toast.update(toastId, {
          render: 'Failed to schedule interviews',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }

      if (blocked.length > 0) {
        toast.warning(
          `Skipped ${blocked.length} candidate${blocked.length > 1 ? 's' : ''} with no email or job role.`,
          { autoClose: 5000 },
        );
      }
      setInterviewDateRange([]);
    }
  };

  const handleScheduleInterviewFromPopup = async (candidate) => {
    dispatch(toggleSchedulePopupState());
    // handleScheduleInterviewForCandidates();
    console.log({ candidate });
  };

  const handleScheduleInterviewFromSourcedProfile = async (candidate) => {
    dispatch(toggleSchedulePopupState());
    // handleScheduleInterviewForCandidates();
  };

  // useEffect(() => {
  //   if (!isSchedulePopupOpen) {
  //     dispatch(removeCandidateFromSelectedList(currentCandidate));
  //   }
  // }, [isSchedulePopupOpen]);

  // Combined Data For Combined Table

  const combinedData = useMemo(() => {
    let merged = [...myUploadsData, ...sourcedProfilesData];

    if (activeSubTab === 'ALL' && sortConfig?.key && sortConfig?.direction) {
      merged = [...merged].sort((a, b) => {
        const getVal = (c) => {
          if (sortConfig.key === 'score') {
            const s = Number(c.score);
            return isNaN(s) ? null : s;
          }
          if (sortConfig.key === 'date') {
            const dateField =
              c._tableSource === 'SOURCED' ? c.applied_at : c.uploaded_on;
            const d = Date.parse(dateField);
            return isNaN(d) ? null : d;
          }
          // default: name or any string field
          return c[sortConfig.key]?.toString().toLowerCase() ?? null;
        };

        const valA = getVal(a);
        const valB = getVal(b);

        if (valA === null && valB === null) return 0;
        if (valA === null) return 1;
        if (valB === null) return -1;

        if (typeof valA === 'number') {
          return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
        }

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return merged;
  }, [myUploadsData, sourcedProfilesData, activeSubTab, sortConfig]);

  const handleScheduleInterviewForAllTab = async (singleCandidate = null, providedRange, options = {}) => {
    const rangeToUse = providedRange || interviewDateRange;
    // Resolve timezone: use passed option or browser/system fallback
    const timezone = options.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeslot = options.timeslot || null;
    if (activeSubTab !== 'ALL') return;
    const candidatesToSchedule = singleCandidate
      ? [singleCandidate]
      : selectedCandidates;

    if (candidatesToSchedule.length === 0) return;

    const myUploadSelected = candidatesToSchedule.filter((c) => !!c.upload_id);
    const sourcedSelected = candidatesToSchedule.filter((c) => !c.upload_id);

    const toastId = toast.loading('Scheduling interviews...');

    try {
      const promises = [];

      if (myUploadSelected.length > 0) {
        promises.push(
          scheduleMyUploadsCandidateInterviews({
            uploadId: myUploadSelected[0]?.upload_id,
            uniqueIds: myUploadSelected.map((c) => c.unique_id),
            startDate: rangeToUse[0],
            endDate: rangeToUse[1],
            org_id,
            timezone,
            timeslot,
          }),
        );
      }

      if (sourcedSelected.length > 0) {
        promises.push(
          scheduleInterviewsFromSourcedProfileService({
            candidates: sourcedSelected,
            dateRange: rangeToUse,
            org_id,
            timezone,
            timeslot,
          }),
        );
      }

      const results = await Promise.all(promises);
      const allSucceeded = results.every(Boolean);

      if (allSucceeded) {
        toast.update(toastId, {
          render: 'Interviews scheduled successfully',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
        dispatch(removeSelectedCandidates());
        dispatch(addCandidatesToScheduledSection(candidatesToSchedule));
      } else {
        toast.update(toastId, {
          render: 'Some interviews failed to schedule',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.update(toastId, {
        render: 'Something went wrong while scheduling interviews',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setInterviewDateRange([]);
      setModalCandidate(null); // ← clear after done
    }
  };

  useEffect(() => {
    // Re-run category filtering when filters are applied
    // This handles cases like score range, date range, source changes
    if (allScreenedCandidates.length > 0) {
      filterDataforMyUploadtables(
        allScreenedCandidates,
        resume_score_threshold,
        notifications,
      );
    }
    if (sourcedCandidates.length > 0) {
      filterDataforSourcedProfiles(sourcedCandidates, resume_score_threshold);
    }
  }, [applyNow]);

  // That work ends here and Pagination work starts
  const totalCandidates =
    activeSubTab === 'ALL'
      ? combinedData.length
      : activeSubTab === 'SOURCED_CANDIDATES'
        ? sourcedProfilesData.length
        : activeSubTab === 'OUTREACHED'
          ? outreachedData.length
          : myUploadsData.length;

  const totalPages = Math.ceil(totalCandidates / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  console.log({ DDDAAAAATTAAAAAAA: activeSubSubTab });
  return (
    <div className="w-full h-full mt-3  pl-2 flex flex-col overflow-hidden">
      {activeTab === 'SOURCED' && (
        <>
          {activeSubTab === 'OUTREACHED' && outreachedLoading && (
            <div className="w-full h-[70vh] flex flex-row items-center justify-center">
              <Loader />
            </div>
          )}

          {(activeSubTab === 'ALL' ||
            activeSubTab === 'MY_UPLOADS' ||
            activeSubTab === 'SOURCED_CANDIDATES' ||
            (activeSubTab === 'OUTREACHED' && !outreachedLoading)) && (
            <CommonTable
              /*
               * Data: pass only the slice that matches the active subtab.
               *   ALL              → combinedData   (MY_UPLOADS + SOURCED merged)
               *   MY_UPLOADS       → myUploadsData tagged with _tableSource
               *   SOURCED_CANDIDATES → sourcedProfilesData tagged with _tableSource
               *   OUTREACHED       → outreachedData (already tagged by toAtsRow)
               */
              combinedData={
                activeSubTab === 'ALL'
                  ? combinedData
                  : activeSubTab === 'MY_UPLOADS'
                    ? myUploadsData.map((c) => ({
                        ...c,
                        _tableSource: 'MY_UPLOADS',
                      }))
                    : activeSubTab === 'OUTREACHED'
                      ? outreachedData
                      : sourcedProfilesData.map((c) => ({
                          ...c,
                          _tableSource: 'SOURCED',
                        }))
              }
              /* Pagination */
              startIndex={startIndex}
              endIndex={endIndex}
              /* Selection */
              selectAllClicked={selectAllClicked}
              handleSelectAllCandidates={handleSelectAllCandidates}
              handleSelectCandidate={handleSelectCandidate}
              /* Row click → report modal */
              handleReportClick={handleReportClick}
              /* Inline email editing */
              editingCandidateId={editingcandidateId}
              editingField={editingField}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onEdit={handleEdit}
              onSave={handleSave}
              /* Sorting */
              sortConfig={sortConfig}
              onSort={handleSort}
              /* Threshold for status badge */
              resume_score_threshold={resume_score_threshold}
              /*
               * Column visibility: pass the per-subtab currentCols so CommonTable
               * knows which columns to render.  The Redux key for MY_UPLOADS is
               * "MY_UPLOADS" and for SOURCED_CANDIDATES is "SOURCED_CANDIDATES";
               * for ALL we pass undefined so CommonTable shows every column.
               */
              currentCols={
                activeSubTab === 'ALL'
                  ? undefined // show all columns in the combined view
                  : currentCols // honour the per-subtab visibility config
              }
              /* Tell CommonTable which subtab we're on so it can adjust labels
           (e.g. "Uploaded On" vs "Applied On") */
              activeSubTab={activeSubTab}
            />
          )}

          {/* {activeSubTab === 'MY_UPLOADS' && (
            <MyUploadsTable
              handleSelectAllCandidates={(isChedked) => {
                handleSelectAllCandidates(isChedked);
              }}
              currentSortDir={currentSortDir}
              selectAllClicked={selectAllClicked}
              activeSubTab={activeSubTab}
              activeSubSubTab={activeSubSubTab}
              myUploadsData={myUploadsData}
              setNewEmail={setNewEmail}
              newEmail={newEmail}
              onSave={handleSave}
              onEdit={handleEdit}
              activeTab={stage}
              setCandidateUniqueID={setCandidateUniqueID}
              stage={stage}
              startIndex={startIndex}
              endIndex={endIndex}
              handleSelectCandidate={handleSelectCandidate}
              editingcandidateId={editingcandidateId}
              handleReportClick={handleReportClick}
              handleSortByName={handleSortByName}
              currentCols={currentCols}
              sortConfig={sortConfig}
              onSort={handleSort}
            />
          )}

          {activeSubTab === 'SOURCED_CANDIDATES' && (
            <SourcedProfileTable
              sourcedProfilesData={sourcedProfilesData}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              startIndex={startIndex}
              endIndex={endIndex}
              handleReportClick={handleReportClick}
              handleSelectCandidate={handleSelectCandidate}
              handleSelectAllCandidates={(val) => {
                handleSelectAllCandidates(val);
              }}
              currentCols={currentCols}
              selectAllClicked={selectAllClicked}
              handleSortByName={handleSortByName}
              sortConfig={sortConfig}
              onSort={handleSort}
            />
          )} */}

          <div className="flex items-center flex-row-reverse justify-between mt-8 w-full">
            <div className="flex space-x-2 mt-8 w-full justify-end">
              {(activeSubSubTab === 'Shortlisted' ||
                activeSubSubTab === 'Retrofit' ||
                activeSubSubTab === 'All') &&
                totalCandidates > 0 && (
                  <button
                    className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                    onClick={() => {
                      dispatch(toggleSchedulePopupState());
                    }}
                    disabled={selectionCount <= 0}
                  >
                    <span>Schedule Interview</span>
                  </button>
                )}

              {/* {activeSubSubTab === 'retrofit' && selectionCount > 0 && (
              <button
                className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                // onClick={}
              >
                <span>Shortlist Selected Candidates</span>
              </button>
            )} */}
            </div>

            <div className="pt-4">
              <Pagination
                currentPage={currentPage}
                totalItems={totalCandidates}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={(size) => {
                  setItemsPerPage(size);
                  setCurrentPage(1);
                }}
                label="Candidates"
              />
            </div>
          </div>
          <AnalysisReportModal
            handleScheduleInterview={(currentCandidate) => {
              if (activeSubTab === 'ALL') {
                setModalCandidate(currentCandidate); // ← store it
                dispatch(toggleSchedulePopupState());
              }
              if (activeSubTab === 'MY_UPLOADS') {
                setModalCandidate(currentCandidate);
                handleScheduleInterviewFromPopup(currentCandidate);
              }
              if (activeSubTab === 'SOURCED_CANDIDATES') {
                setModalCandidate(currentCandidate);
                handleScheduleInterviewFromSourcedProfile(currentCandidate);
              }
            }}
            closeModal={(isClosePressed) => {
              dispatch(toggleReportModalState());
            }}
          />
        </>
      )}

      {outreachBreakdownRow && (
        <ScreeningBreakdownModal
          candidate={outreachBreakdownRow}
          responses={outreachBreakdownRow.responses}
          scoreBreakdown={outreachBreakdownRow.score_breakdown}
          isQualified={outreachBreakdownRow.is_qualified}
          intent={outreachBreakdownRow.intent}
          submittedAt={outreachBreakdownRow.responded_at}
          formId={outreachBreakdownRow.form_id}
          formQuestions={outreachBreakdownRow.questions_snapshot}
          onClose={() => setOutreachBreakdownRow(null)}
        />
      )}

      <ScheduleInterviewDialog
        isSchedulePopupOpen={isSchedulePopupOpen}
        toggleSchedulePopup={(val) => handleCloseSchedulePopup(val)}
        setDateRange={setInterviewDateRange}
        dateRange={interviewDateRange}
        handleScheduleInterviewForCandidates={
          activeSubTab === 'ALL'
            ? (range, options) => handleScheduleInterviewForAllTab(modalCandidate, range, options) // ← forward options
            : handleScheduleInterviewForCandidates
        }
      />
    </div>
  );
}

export default CandidateProfileTable;
